// @flow
import { post, get } from "./common";
import { handleAPIErrors } from '../sentry-util';

export const getLivePods = async(mobile: string, coords: {lat: string, lng: string}, session: string = '') => {
  let reqBody = {};
  try { 
    reqBody = {
      user_id: mobile
    };

    if (coords && coords.lat) {
      reqBody = {
        lat: coords.lat,
        lng: coords.lng,  
      }
    }

    const res = await post('/customer/app/machinelist', reqBody, {session});
    const { status = false } = res;
    if (!status) {
      throw new Error('No machines available');
    }
    return res;
  } catch (error) {
    handleAPIErrors(error, '/customer/app/machinelist', 'POST', reqBody);
    throw error;
  }
}

export const getPodBanners = async(imei: string, session: string = '') => {
  try { 
    const res = await get('https://neuustore.com/tm/promo/banner_v2', { imei, page: 'WEB_PRODUCT' });
    return res.banners;
  } catch (error) {
    handleAPIErrors(error, 'https://neuustore.com/tm/promo/banner_v2', 'GET', { imei, page: 'WEB_PRODUCT' });
    throw error;
  }
}

export const getAffiliateData = async(url: string, mobile: string, session: string = '') => {
  let reqBody = {};
  try { 
    reqBody = {
      user_id: mobile,
      url,
    };

    const res = await get('/afl/validate', { id: url }, {session});
    const { status = false } = res;
    if (!status) {
      throw new Error('No machines available');
    }
    return res;
  } catch (error) {
    handleAPIErrors(error, '/customer/app/machinelist', 'POST', reqBody);
    throw error;
  }
}